import {
  CurrencyCode,
  DateOptionType,
  EnvironmentType,
  JournalHeaderOptionName,
  JournalType,
  PeakExceptionResponseCode,
  SortingType,
} from "@/enums/enums";
import { i18n } from "@/i18n";
import { SettingJournalNameModel, SettingJournalTypeNameModel } from "@/model/document/settingDocumentTemplate";
import Cookies from "js-cookie";

const upperLevelDomain = location.hostname.split(".").slice(-2).join(".");

export function CheckIsDevelop() {
  return process.env.VUE_APP_TYPE_ENV <= EnvironmentType.SIT;
}

export function IsProductionEnvironment() {
  return process.env.VUE_APP_TYPE_ENV >= EnvironmentType.Staging;
}

export function NewObject(obj: any) {
  if (obj == "") {
    return "";
  } else {
    return JSON.parse(JSON.stringify(obj));
  }
}

export function StringToObject(obj: string) {
  if (obj == "") {
    return "";
  } else {
    try {
      return JSON.parse(obj);
    } catch {
      return "";
    }
  }
}

export function UnsetOverflowModalBox(unsetOverflow: any) {
  let elementIdList = document.querySelectorAll("[id='modalBox']");

  if (elementIdList.length > 0) {
    elementIdList.forEach((elementId) => {
      let element = null;
      element = elementId.getElementsByClassName("modalBox")[0];
      if (element) {
        if (unsetOverflow) {
          element.classList.add("unsetOverflow");
          element.classList.add("isCanNotRemoveCalss");
          setTimeout(() => {
            let elementModalBox = elementId.getElementsByClassName("modalBox")[0];
            elementModalBox.classList.remove("isCanNotRemoveCalss");
          }, 500);
        } else {
          if (!element.classList.contains("isCanNotRemoveCalss")) {
            element.classList.remove("unsetOverflow");
          }
        }
      }
    });
  }
}

export function SetDateForInputDate(date: any, isActiveDay = true) {
  let output: String | Date = "";
  let dateStr = date;
  let dateArray = [];
  let yearFirstDateArray = [];
  let slash = dateStr.includes("/");
  let minus = dateStr.includes("-");
  if (slash) {
    dateArray = dateStr.split("/");
    yearFirstDateArray = dateStr.split("/");
  } else if (minus) {
    dateArray = dateStr.split("-");
    yearFirstDateArray = dateStr.split("-");
  } else if (dateStr.length <= 8) {
    if (isActiveDay) {
      dateArray.push(dateStr.substr(0, 2));
      dateArray.push(dateStr.substr(2, 2));
      dateArray.push(dateStr.substr(4, 4));

      yearFirstDateArray.push(dateStr.substr(0, 4));
      yearFirstDateArray.push(dateStr.substr(4, 2));
      yearFirstDateArray.push(dateStr.substr(6, 2));
    } else {
      dateArray.push(dateStr.substr(0, 2));
      dateArray.push(dateStr.substr(2, 4));

      yearFirstDateArray.push(dateStr.substr(0, 4));
      yearFirstDateArray.push(dateStr.substr(4, 2));
    }
  } else {
    dateArray = [];
  }
  let day, month, year;
  if (
    yearFirstDateArray.length > 1 &&
    parseInt(yearFirstDateArray[1]) <= 12 &&
    parseInt(yearFirstDateArray[0]) > 1700
  ) {
    if (isActiveDay) {
      day = parseInt(yearFirstDateArray[2]);
      month = parseInt(yearFirstDateArray[1]);
    } else {
      day = 1;
      month = parseInt(yearFirstDateArray[1]);
    }
    year = parseInt(yearFirstDateArray[0]);
    if (year > 2500) {
      year = year - 543;
    }
    let getDaysInMonth = new Date(year, month, 0).getDate();
    if (day <= getDaysInMonth) {
      output = new Date(year, month - 1, day);
    } else {
      output = "";
    }
  }
  if (dateArray.length > 1 && output === "") {
    if (isActiveDay) {
      day = parseInt(dateArray[0]);
      month = parseInt(dateArray[1]);
    } else {
      day = 1;
      month = parseInt(dateArray[0]);
    }
    if (month <= 12) {
      if (isActiveDay && dateArray[2]) {
        year = parseInt(dateArray[2]);
        if (year > 2500) {
          year = year - 543;
        }
      } else if (!isActiveDay && dateArray[1]) {
        year = parseInt(dateArray[1]);
        if (year > 2500) {
          year = year - 543;
        }
      } else {
        year = new Date().getFullYear();
      }
      let getDaysInMonth = new Date(year, month, 0).getDate();
      if (day <= getDaysInMonth) {
        output = new Date(year, month - 1, day);
      } else {
        output = "";
      }
    } else {
      output = "";
    }
  }
  return output;
}

export function GetMonthName(index: any | string, language = "th"): any {
  const monthListTh = [
    { fullName: "มกราคม", name: "ม.ค." },
    { fullName: "กุมภาพันธ์", name: "ก.พ." },
    { fullName: "มีนาคม", name: "มี.ค." },
    { fullName: "เมษายน", name: "เม.ย." },
    { fullName: "พฤษภาคม", name: "พ.ค." },
    { fullName: "มิถุนายน", name: "มิ.ย." },
    { fullName: "กรกฎาคม", name: "ก.ค." },
    { fullName: "สิงหาคม", name: "ส.ค." },
    { fullName: "กันยายน", name: "ก.ย." },
    { fullName: "ตุลาคม", name: "ต.ค." },
    { fullName: "พฤศจิกายน", name: "พ.ย." },
    { fullName: "ธันวาคม", name: "ธ.ค." },
  ];

  const monthListEn = [
    { fullName: "January", name: "Jan" },
    { fullName: "February", name: "Feb" },
    { fullName: "March", name: "Mar" },
    { fullName: "April", name: "Apr" },
    { fullName: "May", name: "May" },
    { fullName: "June", name: "Jun" },
    { fullName: "July", name: "July" },
    { fullName: "August", name: "Aug" },
    { fullName: "September", name: "Sep" },
    { fullName: "October", name: "Oct" },
    { fullName: "November", name: "Nov" },
    { fullName: "December", name: "Dec" },
  ];

  if (index == "all") {
    if (language == "th") {
      return monthListTh;
    } else {
      return monthListEn;
    }
  } else {
    if (language == "th") {
      return monthListTh[index];
    } else {
      return monthListEn[index];
    }
  }
}

export function GetCurrencyMenuList() {
  let keys = Object.keys(CurrencyCode);
  let values = Object.values(CurrencyCode);
  let currencyList = [];
  for (let index = 0; index < keys.length; index++) {
    currencyList.push({ currencyCode: keys[index], value: values[index] });
  }
  return currencyList;
}

export function GetCurrencyCode(toCurrencyUid: CurrencyCode) {
  let currencyList = GetCurrencyMenuList();
  const currency = currencyList.find((x) => x.value === toCurrencyUid);
  if (currency) {
    return currency.currencyCode;
  } else {
    return "THB";
  }
}

export function Tens(number: string) {
  let _number = number.ToNumber();
  let name = "";
  switch (_number) {
    case 10:
      name = "Ten";
      break;
    case 11:
      name = "Eleven";
      break;
    case 12:
      name = "Twelve";
      break;
    case 13:
      name = "Thirteen";
      break;
    case 14:
      name = "Fourteen";
      break;
    case 15:
      name = "Fifteen";
      break;
    case 16:
      name = "Sixteen";
      break;
    case 17:
      name = "Seventeen";
      break;
    case 18:
      name = "Eighteen";
      break;
    case 19:
      name = "Nineteen";
      break;
    case 20:
      name = "Twenty";
      break;
    case 30:
      name = "Thirty";
      break;
    case 40:
      name = "Forty";
      break;
    case 50:
      name = "Fifty";
      break;
    case 60:
      name = "Sixty";
      break;
    case 70:
      name = "Seventy";
      break;
    case 80:
      name = "Eighty";
      break;
    case 90:
      name = "Ninety";
      break;
    default:
      if (_number > 0) {
        name = Tens(number.substring(0, 1) + "0") + " " + Ones(number.substring(1));
      }
      break;
  }
  return name;
}

export function Ones(number: string) {
  let _name = number.ToNumber();
  let name = "";
  switch (_name) {
    case 1:
      name = "One";
      break;
    case 2:
      name = "Two";
      break;
    case 3:
      name = "Three";
      break;
    case 4:
      name = "Four";
      break;
    case 5:
      name = "Five";
      break;
    case 6:
      name = "Six";
      break;
    case 7:
      name = "Seven";
      break;
    case 8:
      name = "Eight";
      break;
    case 9:
      name = "Nine";
      break;
  }
  return name;
}

export function ConvertWholeNumber(number: string) {
  let word = "";
  let isDone = false; //test if already translated
  let dblAmt = number.ToNumber();
  //if ((dblAmt > 0) && number.StartsWith("0"))
  if (dblAmt > 0) {
    //test for zero or digit zero in a nuemric

    let numDigits = number.length;
    let pos = 0; //store digit grouping
    let place = ""; //digit grouping name:hundres,thousand,etc...
    switch (numDigits) {
      case 1: //ones' range
        word = Ones(number);
        isDone = true;
        break;
      case 2: //tens' range
        word = Tens(number);
        isDone = true;
        break;
      case 3: //hundreds' range
        pos = (numDigits % 3) + 1;
        place = " Hundred ";
        break;
      case 4: //thousands' range
      case 5:
      case 6:
        pos = (numDigits % 4) + 1;
        place = " Thousand ";
        break;
      case 7: //millions' range
      case 8:
      case 9:
        pos = (numDigits % 7) + 1;
        place = " Million ";
        break;
      case 10: //Billions's range
      case 11:
      case 12:
        pos = (numDigits % 10) + 1;
        place = " Billion ";
        break;
      //add extra case options for anything above Billion...
      default:
        isDone = true;
        break;
    }
    if (!isDone) {
      //if transalation is not done, continue...(Recursion comes in now!!)
      if (number.substring(0, pos) != "0" && number.substring(pos) != "0") {
        try {
          word = ConvertWholeNumber(number.substring(0, pos)) + place + ConvertWholeNumber(number.substring(pos));
        } catch {}
      } else {
        word = ConvertWholeNumber(number.substring(0, pos)) + ConvertWholeNumber(number.substring(pos));
      }
    }
    //ignore digit grouping names
    if (word.trim() == place.trim()) word = "";
  }

  return word.trim();
}

export function EnglishBaht(amount: number) {
  let bahtTxt = "";
  bahtTxt = amount.FormatMoney().replace(/,/g, "");
  let val = "",
    wholeNo = bahtTxt,
    points = "",
    andStr = "",
    pointStr = "",
    endStr = "",
    endBaht = "Baht";
  let decimalPlace = bahtTxt.indexOf(".");
  if (decimalPlace >= 0) {
    wholeNo = bahtTxt.substring(0, decimalPlace);
    points = bahtTxt.substring(decimalPlace + 1);
    if (Number(points) > 0) {
      if (wholeNo == "0" || !wholeNo) {
        andStr = "";
        endBaht = "";
      } else {
        andStr = "and"; // just to separate whole numbers from points/cents
      }
      endStr = "Satang " + endStr; //Cents

      let satang = points.substring(0, 2);
      pointStr = Tens(satang);
    } else if (wholeNo == "0" || !wholeNo) {
      endBaht = "Zero " + endBaht;
    }
  }
  val = `${ConvertWholeNumber(wholeNo).trim()} ${endBaht} ${andStr} ${pointStr} ${endStr}`;
  return val;
}

export function ThaiBaht(amount: number) {
  let bahtTxt, n;
  let bahtTH = "";
  let intValSplit = [];

  if (amount < 0) {
    bahtTH = "ลบ";
    amount = amount * -1;
  }

  bahtTxt = amount.FormatMoney().replace(/,/g, "");
  let num = ["ศูนย์", "หนึ่ง", "สอง", "สาม", "สี่", "ห้า", "หก", "เจ็ด", "แปด", "เก้า", "สิบ"];
  let rank = ["", "สิบ", "ร้อย", "พัน", "หมื่น", "แสน", "ล้าน"];
  let temp = bahtTxt.split(".");
  let intVal: any = temp[0];
  let decVal = temp[1];
  if (bahtTxt.ToNumber() == 0) {
    bahtTH = "ศูนย์บาทถ้วน";
  } else {
    while (intVal) {
      let splitVal = "";
      if (intVal.length > 6) {
        splitVal = intVal.substr(intVal.length - 6, 6);
        intVal = intVal.substr(0, intVal.length - 6);
      } else {
        splitVal = intVal;
        intVal = null;
      }
      intValSplit.push(splitVal);
    }

    intValSplit.reverse();
    let intValSplitCount = intValSplit.length;

    intValSplit.forEach((value) => {
      let intcount = 0;
      for (let i = 0; i < value.length; i++) {
        n = value.substr(i, 1);
        if (n != "0") {
          if (intcount >= 1 && i == value.length - 1 && n == "1") {
            bahtTH += "เอ็ด";
          } else if (i == value.length - 2 && n == "2") {
            bahtTH += "ยี่";
          } else if (i == value.length - 2 && n == "1") {
            bahtTH += "";
          } else {
            bahtTH += num[n.ToNumber()];
          }

          bahtTH += rank[value.length - i - 1];
          intcount++;
        }
      }
      if (intValSplitCount != 1) {
        bahtTH += rank[6];
      }
      intValSplitCount--;
    });

    if (bahtTH.trim().length > 0) {
      bahtTH += "บาท";
    }
    if (decVal == "00") {
      if (bahtTH.trim().length > 0) {
        bahtTH += "ถ้วน";
      }
    } else {
      let deccount = 0;

      for (let i = 0; i < decVal.length; i++) {
        n = decVal.substr(i, 1);
        if (n != "0") {
          if (deccount >= 1 && i == decVal.length - 1 && n == "1") {
            bahtTH += "เอ็ด";
          } else if (i == decVal.length - 2 && n == "2") {
            bahtTH += "ยี่";
          } else if (i == decVal.length - 2 && n == "1") {
            bahtTH += "";
          } else {
            bahtTH += num[n.ToNumber()];
          }
          bahtTH += rank[decVal.length - i - 1];
          deccount++;
        }
      }
      bahtTH += "สตางค์";
    }
  }

  return bahtTH;
}

export function ConvertAmountToThaiWord(amount: number, currencyCode: CurrencyCode) {
  let bahtTHWithCurrency = ThaiBaht(amount);
  if (currencyCode !== CurrencyCode.THB) {
    let decimalWord = "";
    if (amount < 0) {
      decimalWord = "ลบ";
      amount = amount * -1;
    }
    let decimalString = amount.FormatMoney().replace(/,/g, "");
    decimalString = decimalString.substring(decimalString.lastIndexOf(".") + 1);
    let decimalCharArray = decimalString.split("");
    decimalCharArray.forEach((decimalCharArrayMember) => {
      let decimalIntArrayMember = parseInt(decimalCharArrayMember);
      let singleDecimalWord = "";
      switch (decimalIntArrayMember) {
        case 1:
          singleDecimalWord = "หนึ่ง";
          break;
        case 2:
          singleDecimalWord = "สอง";
          break;
        case 3:
          singleDecimalWord = "สาม";
          break;
        case 4:
          singleDecimalWord = "สี่";
          break;
        case 5:
          singleDecimalWord = "ห้า";
          break;
        case 6:
          singleDecimalWord = "หก";
          break;
        case 7:
          singleDecimalWord = "เจ็ด";
          break;
        case 8:
          singleDecimalWord = "แปด";
          break;
        case 9:
          singleDecimalWord = "เก้า";
          break;
        case 0:
          singleDecimalWord = "ศูนย์";
          break;
      }
      decimalWord += singleDecimalWord;
    });
    if (bahtTHWithCurrency.includes("บาท") && bahtTHWithCurrency.includes("สตางค์")) {
      bahtTHWithCurrency = bahtTHWithCurrency.replace("บาท", "จุด");
      bahtTHWithCurrency = bahtTHWithCurrency.replace("สตางค์", "");
      bahtTHWithCurrency = bahtTHWithCurrency.substring(0, bahtTHWithCurrency.lastIndexOf("จุด"));
      bahtTHWithCurrency = `${bahtTHWithCurrency}จุด${decimalWord}`;
    }

    if (bahtTHWithCurrency.includes("บาท") && !bahtTHWithCurrency.includes("สตางค์")) {
      bahtTHWithCurrency = bahtTHWithCurrency.replace("บาท", "");
    }

    if (bahtTHWithCurrency.includes("สตางค์") && !bahtTHWithCurrency.includes("บาท")) {
      bahtTHWithCurrency = `ศูนย์จุด${decimalWord}`;
    }

    bahtTHWithCurrency = `(${GetCurrencyCode(currencyCode)}) ${bahtTHWithCurrency}`;
  }

  return bahtTHWithCurrency;
}

export function ConvertAmountToEnglishWord(amount: number, currencyCode: CurrencyCode) {
  let bahtENWithCurrency = EnglishBaht(amount);

  if (currencyCode != CurrencyCode.THB) {
    let decimalString = amount.FormatMoney().replace(/,/g, "");
    decimalString = decimalString.substring(decimalString.lastIndexOf(".") + 1);
    let decimalCharArray = decimalString.split("");
    let decimalWord = "";
    decimalCharArray.forEach((decimalCharArrayMember) => {
      let decimalIntArrayMember = parseInt(decimalCharArrayMember);
      let singleDecimalWord = "";
      switch (decimalIntArrayMember) {
        case 1:
          singleDecimalWord = "One";
          break;
        case 2:
          singleDecimalWord = "Two";
          break;
        case 3:
          singleDecimalWord = "Three";
          break;
        case 4:
          singleDecimalWord = "Four";
          break;
        case 5:
          singleDecimalWord = "Five";
          break;
        case 6:
          singleDecimalWord = "Six";
          break;
        case 7:
          singleDecimalWord = "Seven";
          break;
        case 8:
          singleDecimalWord = "Eight";
          break;
        case 9:
          singleDecimalWord = "Nine";
          break;
        case 0:
          singleDecimalWord = "Zero";
          break;
      }
      decimalWord = `${decimalWord} ${singleDecimalWord}`;
    });

    if (bahtENWithCurrency.includes(" and ") && bahtENWithCurrency.includes("Satang")) {
      bahtENWithCurrency = bahtENWithCurrency.replace(" and ", "point ");
      bahtENWithCurrency = bahtENWithCurrency.replace("Satang", "");
      bahtENWithCurrency = bahtENWithCurrency.replace("Baht", "");
      bahtENWithCurrency = bahtENWithCurrency.substring(0, bahtENWithCurrency.lastIndexOf("point"));
      bahtENWithCurrency = `${bahtENWithCurrency}point ${decimalWord}`;
    }

    if (bahtENWithCurrency.includes(" and ") && !bahtENWithCurrency.includes("Satang")) {
      bahtENWithCurrency = bahtENWithCurrency.replace(" and ", "");
    }

    if (
      bahtENWithCurrency.includes("Baht") &&
      !bahtENWithCurrency.includes("Satang") &&
      !bahtENWithCurrency.includes(" and ")
    ) {
      bahtENWithCurrency = bahtENWithCurrency.replace("Baht", "");
    }

    if (amount == 0) {
      bahtENWithCurrency = "Zero";
    }

    if (bahtENWithCurrency.includes("Satang") && !bahtENWithCurrency.includes(" and ")) {
      bahtENWithCurrency = `Zero point ${decimalWord}`;
    }

    bahtENWithCurrency = `(${GetCurrencyCode(currencyCode)}) ${bahtENWithCurrency}`;
  }

  return bahtENWithCurrency;
}

export function CheckTextTooLong(amountCharacter: number, limitAmountCharacter: number) {
  return amountCharacter > limitAmountCharacter;
}

export function GetJournalTypeName(journalType: number) {
  let journalTypeName: any = "";

  switch (journalType) {
    case JournalType.PurchaseJournal:
      journalTypeName = i18n.t("Menu_PurchaseJournal");
      break;
    case JournalType.SalesJournal:
      journalTypeName = i18n.t("Menu_SalesJournal");
      break;
    case JournalType.PaymentJournal:
      journalTypeName = i18n.t("Menu_PaymentJournal");
      break;
    case JournalType.ReceiveJournal:
      journalTypeName = i18n.t("Menu_ReceivedJournal");
      break;
    case JournalType.GeneralJournal:
      journalTypeName = i18n.t("Menu_GeneralJournal");
      break;
  }

  return journalTypeName;
}

export function GetJournalNameTypeModel(journalType: JournalType): SettingJournalNameModel {
  return {
    headerOptionName: JournalHeaderOptionName.MainJournalHeader,
    isShowElement: true,
    value: GetMainJournalTypeNameHeader(journalType),
  };
}

export function GetJournalNameType(journalType: JournalType, documentNameType: SettingJournalTypeNameModel) {
  let documentName: SettingJournalNameModel = new SettingJournalNameModel();

  switch (journalType) {
    case JournalType.PurchaseJournal:
      documentName = documentNameType.purchaseJournal;
      break;
    case JournalType.SalesJournal:
      documentName = documentNameType.salesJournal;
      break;
    case JournalType.PaymentJournal:
      documentName = documentNameType.paymentJournal;
      break;
    case JournalType.ReceiveJournal:
      documentName = documentNameType.receiveJournal;
      break;
    case JournalType.GeneralJournal:
      documentName = documentNameType.generalJournal;
      break;
  }

  return documentName;
}

export function GetMainJournalTypeNameHeader(journalType: JournalType) {
  let journalTypeName = "";

  switch (journalType) {
    case JournalType.PurchaseJournal:
      journalTypeName = "Menu_PurchaseJournal";
      break;
    case JournalType.SalesJournal:
      journalTypeName = "Menu_SalesJournal";
      break;
    case JournalType.PaymentJournal:
      journalTypeName = "Menu_PaymentJournal";
      break;
    case JournalType.ReceiveJournal:
      journalTypeName = "Menu_ReceivedJournal";
      break;
    case JournalType.GeneralJournal:
      journalTypeName = "Menu_GeneralJournal";
      break;
  }

  return journalTypeName;
}

export function GetVoucherJournalTypeNameHeader(journalType: JournalType) {
  let journalTypeName = "";

  switch (journalType) {
    case JournalType.PurchaseJournal:
      journalTypeName = "Purchase_Voucher";
      break;
    case JournalType.SalesJournal:
      journalTypeName = "Sales_Voucher";
      break;
    case JournalType.PaymentJournal:
      journalTypeName = "Payment_Voucher";
      break;
    case JournalType.ReceiveJournal:
      journalTypeName = "Receive_Voucher";
      break;
    case JournalType.GeneralJournal:
      journalTypeName = "General_Voucher";
      break;
  }

  return journalTypeName;
}

export function GetDateFormatOption(date: Date, dateOptionType: DateOptionType) {
  const dayDate = new Date(date).getDate();
  const dateStr = dayDate.toString().length === 2 ? dayDate : "0" + dayDate;
  const mounth = new Date(date).getMonth();
  const mounthStr = (mounth + 1).toString().length === 2 ? mounth + 1 : "0" + (mounth + 1);
  const fullYear = new Date(date).getFullYear();
  const fullYearBE = fullYear.GetYearBE();

  if (date == null || isNaN(dayDate.ToNumber()) || isNaN(mounth.ToNumber()) || isNaN(fullYear)) {
    return "-";
  } else {
    let dateFormat = "";

    switch (dateOptionType) {
      case DateOptionType.DateADType1:
        dateFormat = `${dateStr}/${mounthStr}/${fullYear}`;
        break;
      case DateOptionType.DateBEType1:
        dateFormat = ` ${dateStr}/${mounthStr}/${fullYearBE}`;
        break;
      case DateOptionType.DateADType2:
        dateFormat = `${dateStr} ${GetMonthName(mounth, i18n.locale).name} ${fullYear}`;
        break;
      case DateOptionType.DateBEType2:
        dateFormat = `${dateStr} ${GetMonthName(mounth, i18n.locale).name} ${fullYearBE}`;
        break;
    }

    return dateFormat;
  }
}

export function GetPeriod(date: Date) {
  const newDate = new Date(date);
  const year = newDate.getFullYear();
  let month = (newDate.getMonth() + 1).toString();
  month = month.length == 2 ? month : "0" + month;
  return month + "/" + year;
}

export function CompareDataListForSorting(dataListA: any, dataListB: any, sortingType: number) {
  if (sortingType === SortingType.ASC) {
    if (dataListA < dataListB) {
      return -1;
    } else if (dataListA > dataListB) {
      return 1;
    } else {
      return 0;
    }
  } else {
    if (dataListA > dataListB) {
      return -1;
    } else if (dataListA < dataListB) {
      return 1;
    } else {
      return 0;
    }
  }
}

export function GetUserApproveDate(date: Date) {
  let day = "";
  let month = "";
  let year = "";
  const minDate = new Date(0);
  const newDate = new Date(date);
  if (newDate >= minDate) {
    day = newDate.getDate().toString();
    month = GetMonthName(newDate.getMonth(), i18n.locale).name;
    year = newDate.getFullYear().toString();
  }
  return { day: day, month: month, year: year };
}

export function GetMessageExceptionCode(exception: any) {
  let message: any = "";

  switch (exception.exceptionCode) {
    case PeakExceptionResponseCode.InvalidDocumentPassCode:
      message = i18n.t("Wrong_Passcode");
      break;
    default:
      message = i18n.t("Something_Wrong") + exception.exceptionCode ? " Error Code:" + exception.exceptionCode : "";
      break;
  }
  return message;
}

export function SetCookie(cookieName: string, pagesize: any, expireDays: number) {
  if (upperLevelDomain === "peakaccount.com") {
    Cookies.set(cookieName, pagesize, { expires: expireDays, domain: ".peakaccount.com" });
  } else {
    Cookies.set(cookieName, pagesize, { expires: expireDays });
  }
}

export function GetCookie(cookieName: string) {
  return Cookies.get(cookieName);
}

export function ValidateEmailFormatError(email: string) {
  const re =
    /^(([^<>!()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function IsKeyBoardEN(str: string) {
  if (str) {
    const RegExr = /^[a-zA-Z0-9$@$!%*?&#^-_. +()]+$/g;
    if (str.match(RegExr)) {
      return true;
    } else {
      return false;
    }
  }
}
